module.exports = __webpack_public_path__ + "static/media/terms-and-conditions-icon.f35888d0.svg";